import AdvisoryServicesPage from './Advisory.jsx';
export default AdvisoryServicesPage;
